import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = (theme) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  px: 1,
  py: 0.5,
  minWidth: 156,
  justifyContent: "space-between",
});

export const value: SxProps<Theme> = {
  fontWeight: 700,
  minWidth: 48,
  textAlign: "center",
};

export const iconButton: SxProps<Theme> = (theme) => ({
  color: theme.palette.primary.main,
});
